import { render, staticRenderFns } from "./CatalogCard.vue?vue&type=template&id=769072ce&scoped=true&"
import script from "./CatalogCard.vue?vue&type=script&lang=ts&"
export * from "./CatalogCard.vue?vue&type=script&lang=ts&"
import style0 from "./CatalogCard.vue?vue&type=style&index=0&id=769072ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769072ce",
  null
  
)

export default component.exports